import React from 'react';

interface IErrorBoundaryProps {
    children: any;
    // readonly children: JSX.Element | JSX.Element[];
}

interface IErrorBoundaryState {
    error: any;
    errorInfo: any;
}

class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
    // readonly state: IErrorBoundaryState = { error: undefined, errorInfo: undefined };
    constructor(props) {
        super(props);
        this.state = { error: undefined, errorInfo: undefined };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({ error, errorInfo });
    }

    render() {
        const { error, errorInfo } = this.state;
        if (errorInfo) {
            const errorDetails = (
                // process.env.NODE_ENV === 'development' ? (
                <div className="preserve-space">
                    {error && error.toString()}
                    <br />
                    {errorInfo.componentStack}
                </div>
                /*) : (
                    undefined
                );*/
            );
            return (
                <div className="error-boundary">
                    <h2 className="error">An unexpected error has occurred.</h2>
                    {errorDetails}
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
